import type { UserDetails } from "@project/api";
import { createAction, createReducer, createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";

export interface UserState {
  current: UserDetails | null;
}

const initialState: UserState = {
  current: null,
};

export const setUser = createAction<UserDetails | null>("user/setUser");

export const userReducer = createReducer(initialState, (builder) => {
  builder.addCase(setUser, (state, action) => {
    state.current = action.payload;
  });
});

export const getUserSelector = createSelector(
  (state: RootState) => state,
  state => state.user.current,
);

export const getCurrentAccountSelector = createSelector(
  (state: RootState) => state,
  state => state.user.current?.currentAccount,
);

export const getUserCurrentAccountNameSelector = createSelector(
  (state: RootState) => state,
  state => state.user.current?.currentAccount?.name,
);

export const getUserIsServiceAccountSelector = createSelector(
  (state: RootState) => state,
  state => Boolean(state.user.current?.currentAccount?.isServiceAccount),
);

export const getUserIsDeveloperPartnerSelector = createSelector(
  (state: RootState) => state,
  state => Boolean(state.user.current?.currentAccount?.isDevelopmentPartner),
);
